import React from 'react';
import { Box, Card, Typography, Stack } from '@mui/material';

const KpiCard = ({ label, value, hint, color = 'primary.main' }) => (
  <Card sx={{ p: 2, flex: 1, minWidth: 160 }}>
    <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.6 }}>
      {label}
    </Typography>
    <Stack direction="row" alignItems="baseline" spacing={1} sx={{ mt: 0.5 }}>
      <Typography variant="h4" sx={{ color, fontWeight: 700 }}>
        {value}
      </Typography>
      {hint ? (
        <Typography variant="body2" color="text.secondary">
          {hint}
        </Typography>
      ) : null}
    </Stack>
  </Card>
);

export default KpiCard;
